import { type FC } from 'react';
import { useIntl, type MessageDescriptor } from 'dibs-react-intl';
import { SingleSelect } from 'dibs-elements/exports/SingleSelect.tsx';
import { Radio } from 'dibs-elements/exports/Radio.tsx';

type Props = {
    value: string | null;
    onChange: (newValue?: string) => void;
    placeholder: string;
    dataTn: string;
    name: string;
    options: Array<{ value: string | null; label: MessageDescriptor }>;
};

export const NftMarketSingleSelectFilter: FC<Props> = ({
    value,
    onChange,
    options,
    placeholder,
    dataTn,
    name,
}) => {
    const { formatMessage } = useIntl();

    return options.length === 0 ? null : (
        <SingleSelect
            value={undefined}
            onChange={selection => onChange(selection?.value)}
            options={options.map(option => {
                const label = formatMessage(option.label);
                return {
                    label,
                    value: option.value ?? '',
                    customDropdownDisplay: (
                        <Radio
                            checked={value === option.value || (!value && !option.value)}
                            dataTn={`${dataTn}-option-${label}`}
                            name={`${dataTn}-option-${label}`}
                            onChange={() => {}}
                            label={label}
                            value={option.value ?? ''}
                        />
                    ),
                };
            })}
            name={name}
            placeholder={placeholder}
            dataTn={dataTn}
            dropdownDetachedMode
            clearable={false}
            size="medium"
        />
    );
};
